import globals from '../../../../scripts/modules/globals';
import parameters from '../../../../scripts/modules/parameters';

const deactivateMenus = ( current ) => {
	let menus = document.querySelectorAll('.filter__menu');
	menus.forEach( (menu) => {
		if ( menu.id !== current.id ) {
			menu.style.display = 'none';
			menu.parentNode.querySelector('.filter__tab').classList.remove('is-active');
		}
	});
}

const toggle = ( tab ) => {
	let menu = tab.parentNode.querySelector('.filter__menu');
	if ( menu.style.display === 'none' ) {
		deactivateMenus( menu );
		menu.style.display = 'block';
		tab.classList.add('is-active');
	} else {
		menu.style.display = 'none';
		tab.classList.remove('is-active');
	}
}

const pluralize = ( value, singular ) => {
	if ( typeof value === 'object' ) {
		return ( value.length > 1 ) ? singular + 's' : singular;
	} else if ( typeof value === 'number' || typeof value === 'string' ) {
		return ( parseInt(value) > 1 ) ? singular + 's' : singular;
	}
}

const arrayToLabel = ( obj ) => {
	let keys = Object.keys(obj).filter((key) => key !== 'length');
	let arr = keys.map((key) => obj[key]);
	return arr.length === 2 ? arr.join(' & ') : arr.join(', ');
}

const update = ( tab ) => {
	let placeholder = tab.getAttribute('data-placeholder');
	let singular = tab.getAttribute('data-singular');
 	let key = tab.getAttribute('data-key');
	let type = tab.parentNode.getAttribute('data-type');
 	let value = parameters.getKey(key);
	let valueDefault = 'Any';
	let label = singular ? pluralize( value, singular ) : '';
	let prefix = tab.getAttribute('data-prefix');
	if ( value === '$undefined'){ value = false;}
 	switch ( type ) {
		 case 'string': // {Value} || Allows Dogs
			const opt = document.getElementById(value);	
			label = opt ? opt.getAttribute('data-label') : '';	 
			if(prefix) {
				tab.innerHTML = value ? prefix + label : placeholder;
			} else {
				tab.innerHTML = value ? value : placeholder;
			}
 			break;
		case 'array': // {Value} {Name} || (1) Neighborhood
			value = value ? arrayToLabel(value) : '';
			label = prefix ? prefix + value : value;
 			tab.innerHTML = value ? label : placeholder;
 			break;
 		case 'array-counted': // {Value} {Name} || (1) Neighborhood
 			tab.innerHTML = value ? value.length + ' ' + label : placeholder;
 			break;
 		case 'int': // {Value} {Name} || 2 Beds
			tab.innerHTML = value ? value + ' ' + label : placeholder;
 			break;
 		case 'int-range-price': // {ValueA} - {ValueB} || $500 - $1500
 			let keyA = tab.getAttribute('data-key-a');
 			let keyB = tab.getAttribute('data-key-b');
 			let valueA = parameters.getKey(keyA) ? '$' + parameters.getKey(keyA) : valueDefault;
 			let valueB = parameters.getKey(keyB) ? '$' + parameters.getKey(keyB) : valueDefault;
			if ( valueA === '$undefined'){ valueA = valueDefault;}
			if ( valueB === '$undefined'){ valueB = valueDefault;}
			tab.innerHTML = ( valueA !== valueDefault || valueB !== valueDefault ) ? `${valueA} - ${valueB}` : placeholder;
 			break;
 	}
}

const init = () => {
	let filter = document.getElementById('filter');
	let tabs = document.querySelectorAll('.filter__tab');
	tabs.forEach( ( tab ) => update( tab ) );
	filter.onclick = (e) => {
			if ( e.target.classList.contains('filter__tab') ) {
			toggle(e.target);
			update( e.target );
		}
	}
}

export default {
	toggle,
	update,
	init
}
